module.exports = __webpack_public_path__ + "static/media/mariana-baptista.5464f5da.png";